"use client";

import React, { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { Package, Search } from "lucide-react";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";
import { Dock, DockItem } from "modules/common/components/ui/dock";
import MatchedCardsIcon from "modules/common/components/Icons/MatchedCardsIcon";

interface LGSPageMobileTabsProps {
  slug: string;
  basePath?: string;
  /** The anonymous <VisitorCtaBar variant="stacked">, above the dock items. */
  cta?: ReactNode;
}

export function LGSPageMobileTabs({
  slug,
  basePath,
  cta,
}: LGSPageMobileTabsProps) {
  const pathname = usePathname();
  const base = basePath ?? `/stores/${slug}`;

  return (
    <Dock className="md:hidden" header={cta}>
      <DockItem
        href={`${base}/haves`}
        icon={<Package size={ICON_SIZE} />}
        isActive={pathname?.includes("/haves") ?? false}
      >
        Haves
      </DockItem>
      <DockItem
        href={`${base}/wants`}
        icon={<Search size={ICON_SIZE} />}
        isActive={pathname?.includes("/wants") ?? false}
      >
        Wants
      </DockItem>
      <DockItem
        href={`${base}/matched`}
        icon={<MatchedCardsIcon fontSize={ICON_SIZE} />}
        isActive={pathname?.includes("/matched") ?? false}
      >
        Matches
      </DockItem>
    </Dock>
  );
}
